import { isAccommodation } from "@@/shared/acquire/is-accommodation";
import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import type { TimeRange } from "@@/shared/date-time/time-range";
import { isOrderItemBookable } from "@@/shared/orders/order-items/is-order-item";
import { isOrderItemAccommodation_V2 } from "@@/shared/orders/order-items/is-order-item-v2";
import { isBookable } from "../acquire/is-bookable";
import { asDate } from "../date-time/as-date";
import { dateTimeFormatter } from "../date-time/date-time-formatter";
import type { Translatable} from "../translations/translation";
import { translation } from "../translations/translation";
import type { Order } from "./order";

const getBookableOrderStart = (
    order: Order,
): IsoAndUnixTimestamp | undefined => {
    return getBookingOrderTime(order)?.start;
};

const getBookingOrderTime = (order: Order): TimeRange | undefined => {
    if (isAccommodation(order)) {
        return order.orderItems.find(isOrderItemAccommodation_V2)?.time;
    }

    if (isBookable(order)) {
        const bookable = order.orderItems.find(isOrderItemBookable);
        return bookable?.time;
    }

    return undefined;
};

const getBookingOrderStartFormatted = (
    order: Order,
): Translatable | undefined => {
    const start = getBookingOrderTime(order);
    return getIsoStartFormatted(start?.start);
};

const getIsoStartFormatted = (start: IsoAndUnixTimestamp | undefined) => {
    return translation({
        sv: `${
            start
                ? dateTimeFormatter("sv").formatDateAndTimeLong(start)
                : "okänt"
        }`,
        en: `${
            start
                ? dateTimeFormatter("en").formatDateAndTimeLong(start)
                : "unknown"
        }`,
    });
};

const getBookableOrderYear = (order: Order): Translatable | undefined => {
    if (!isBookable(order)) return undefined;
    const start = getBookableOrderStart(order);
    if (!start) return undefined;
    return asDate(start).getFullYear().toString();
};
export {
    getBookableOrderStart,
    getBookableOrderYear,
    getBookingOrderStartFormatted,
    getBookingOrderTime,
    getIsoStartFormatted,
};
